// extracted by mini-css-extract-plugin
module.exports = {"subtitleConfiguracao":"styles_subtitleConfiguracao__uuX-8","addLojasWrapper":"styles_addLojasWrapper__3Qfay","table":"styles_table__1dFcd"};